import { useState, useCallback } from 'react';
import { SETTINGS_KEY } from '../utils/constants';

const DEF_SETTINGS = {
  monitorSetup: 'single',
  alertSleepyMinutes: 10,
  // legacy holofit kept for backward compat
  holofitUrl: '', holofitEnabled: false,
};

export function useSettings() {
  const [settings, setSettings] = useState(() => {
    try { return { ...DEF_SETTINGS, ...JSON.parse(localStorage.getItem(SETTINGS_KEY) || '{}') }; }
    catch { return DEF_SETTINGS; }
  });

  const saveSettings = useCallback(updates => {
    setSettings(prev => {
      const next = { ...prev, ...updates };
      try { localStorage.setItem(SETTINGS_KEY, JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);

  return { settings, saveSettings };
}
